import { Dispatch } from 'redux'
import { Scorecard } from 'util/scorecard'
import { getDriverScorecardSummary } from 'util/server/scorecard'

type SetScorecardSummaryDispatch = Dispatch<{
  type: 'SET_SCORECARD_SUMMARY'
  scorecardSummary: Scorecard[]
}>

export function fetchDriverScorecardSummary(profileId: number) {
  return async (dispatch: SetScorecardSummaryDispatch) => {
    return getDriverScorecardSummary(profileId).then((resp) => {
      const scorecardSummary = Array.isArray(resp.data) ? resp.data : []
      return dispatch({ type: 'SET_SCORECARD_SUMMARY', scorecardSummary })
    })
  }
}
